module.exports = __webpack_public_path__ + "img/aicon1.16b655a5.png";